import {EventType, TrackingEventDefinition, TrackingKey} from "./tracking.js";
import {EventData} from "./dataLayer.js";
import {TrackingEventDefinitionReader} from "./trackingEventDefinitionReader.js";
import {TrackingEvent} from "./trackingService.js";

export class TrackingEventDataLookup {
    private readonly table = new Map<TrackingKey, Map<EventType, EventData>>();

    private readonly definitionReader: TrackingEventDefinitionReader;

    constructor() {
        this.table = new Map();
        this.definitionReader = new TrackingEventDefinitionReader(this.onDefinitionAdded.bind(this));
        this.definitionReader.start();
    }

    public find(event: TrackingEvent): EventData|undefined {
        return this.table.get(event.trackingKey)?.get(event.eventType);
    }

    private onDefinitionAdded(definition: TrackingEventDefinition) {
        for (const trigger of definition.triggers) {
            let eventTypeData = this.table.get(trigger.trackingKey);
            if (eventTypeData === undefined) {
                eventTypeData = new Map();
                this.table.set(trigger.trackingKey, eventTypeData);
            }
            eventTypeData.set(trigger.eventType, definition.eventData);
        }
    }
}
